import { v1 } from './common/clients';

export default {
  getByHash: (hash) => v1.get(`/billings/deposits/${hash}`),
  startPayment: (hash) => v1.post(`/billings/deposits/${hash}`),
  getPaymentLink: (placeUri, body) => v1.post(`/payment/${placeUri}/checkout`, body),
  buyCertificate: (placeUri, body) => v1.post(`/places/${placeUri}/certificates/buy`, body),
  findCertificate: (placeUri, uuid) => v1.post(`/places/${placeUri}/certificates/search`, { uuid }),
};
